export const MIN_RATING_COUNT = 10;
export const MIN_RATING_AVERAGE = 4;
